// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PWomanOutlinedSvg from "@fishx/icons-svg/es/asn/PWomanOutlined";
import FishxIcon from '../components/FishxIcon';

var PWomanOutlined = function PWomanOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PWomanOutlinedSvg
  }));
};

PWomanOutlined.displayName = 'PWomanOutlined';
export default React.forwardRef(PWomanOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PWomanOutlined.js
// module id = 3733
// module chunks = 0